<button
  mat-icon-button
  color="primary"
  (click)="openStyleModalDialog()"
  [matTooltip]="'igo.geo.style.styleModalTooltipLayer' | translate"
>
  <mat-icon class="style-icon">palette </mat-icon>
</button>
